<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-2">
        {{ $t("add") }} {{ $tc("banner", 1) }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'Web Banners' }"
        >{{ $tc("banner", 1) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <div class="row mx-1">
        <div
          class="col-12 d-flex new-border back rounded-10"
          style="flex-wrap:wrap;padding-top:11px;padding-left:0px;padding-right:0px"
        >
          <div class="col-lg-6 col-xl-3 align-self-center mb-0">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    banner_type && banner_type.length > 0 ? 'shift-up' : ''
                  "
                  >{{ $tc("banner", 1) }} {{ $tc("type", 1) }}
                </label>
                <b-dropdown
                  :text="banner_type"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(bannerType, bannerTypeIndex) in banner_types"
                    :key="bannerTypeIndex"
                    v-on:click="onSelectBannerType(bannerType)"
                    >{{ bannerType.banner_type }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
            <p class="error_message" style="margin-top:2px"></p>
          </div>

          <!-- CINEMA SELECTION -->

          <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="cinemaSelected"
                placeholder="Select Cinema"
                :options="cinemas"
                label="cine_name"
                track-by="cine_id"
                :multiple="false"
              />
            </div>
          </div>
        </div> -->
          <!-- CINEMA SELECTION -->

          <div class="col-lg-6 col-xl-3 align-self-center mb-0">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  id="banner_name"
                  name="banner_name"
                  v-validate="'required'"
                  v-model="banner_name"
                  placeholder="."
                  maxlength="100"
                  v-on:keydown="checkInputLength"
                  v-b-tooltip.hover
                  :title="$t('banner_name')"
                />
                <label>Name</label>
              </div>
              <!--Tooltip :title="$t('banner_name')" /-->
            </div>
            <p class="error_message" style="margin-top:2px">
              <span v-if="submitted && errors.has('banner_name')">{{
                errors.first("banner_name")
              }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-0">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  id="banner_description"
                  name="banner_description"
                  v-validate="'required'"
                  v-model="banner_description"
                  placeholder="Description"
                  maxlength="300"
                  v-on:keydown="checkInputLength"
                  v-b-tooltip.hover
                  :title="$t('banner_description')"
                />
                <label>Description</label>
              </div>
              <!--Tooltip :title="$t('banner_description')" /-->
            </div>
            <p class="error_message" style="margin-top:2px">
              <span v-if="submitted && errors.has('banner_description')">{{
                errors.first("banner_description")
              }}</span>
            </p>
          </div>
          <div class="col-2 d-flex align-self-center align-items-center pb-3">
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox mb-0"
              v-model="banner_is_active"
            />

            <label class="mb-0 mr-2 switch-text">{{ $t("active") }}</label>
          </div>

          <div
            v-if="banner_type_id === 1 || banner_type_id === 2"
            class=" col-12 row pt-2 mb-3 new-border rounded-10"
            style="background-color:white;padding-left:0px;margin-left:15px;max-width:95%;"
          >
            <div
              v-if="banner_type_id === 1"
              class="col-lg-6 col-xl-4 align-self-center mb-2"
            >
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      movie_name && movie_name.length > 0 ? 'shift-up' : ''
                    "
                    >{{ $tc("movie", 1) }}</label
                  >
                  <b-dropdown
                    :text="movie_name"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search Movie"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchMovie($event.target.value)"
                        v-on:keydown="onSearchMovie($event.target.value)"
                        v-on:search="onSearchMovie($event.target.value)"
                        v-model="searchMovie"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(movie, movieIndex) in MovieList"
                      :key="movieIndex"
                      v-on:click="onSelectMovie(movie)"
                      >{{ movie.movie_title }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
            </div>

            <div
              class="col-lg-8 mb-2 align-self-center"
              v-if="banner_type_id === 1"
            >
              <div class="row mx-0">
                <b-form-checkbox
                  v-for="(type, typeIndex) in movieType"
                  :key="typeIndex"
                  v-model="type.checked"
                  class="j-checkbox mx-3 "
                >
                  <div class="text-capitalize">{{ type.name }}</div>
                </b-form-checkbox>
              </div>
            </div>

            <div class="col-lg-6 mb-4" v-if="banner_type_id === 1 && false">
              <div class="d-flex align-items-center">
                <b-form-radio
                  :value="1"
                  class="j-radio"
                  v-model="movie_banner_type_id"
                >
                  <div>
                    <span>{{ "Now Showing" }}</span>
                  </div>
                </b-form-radio>
                <strong class="mx-3">OR</strong>

                <b-form-radio
                  :value="2"
                  class="j-radio"
                  v-model="movie_banner_type_id"
                >
                  <div>
                    <span>{{ "On Demand" }}</span>
                  </div>
                </b-form-radio>
              </div>
            </div>

            <div
              class="col-lg-6 col-xl-4 align-self-center mb-2"
              v-if="banner_type_id === 2"
            >
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    id="generic_url"
                    name="generic_url"
                    @input="OnType($event)"
                    v-model="generic_url"
                    placeholder="."
                    maxlength="255"
                    v-on:keydown="checkInputLength"
                  />
                  <label>Generic URL</label>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-5 col-xl-3 mb-5 pr-0" v-if="banner_type_id">
          <label class="material-file-upload">
            <input
              :disabled="isMovieSelected"
              type="file"
              v-on:change="setBannerImage($event)"
              name="image"
              id="image"
            />
            <div
              class="label"
              v-bind:class="{
                'shift-up':
                  banner_image.image_setting_path &&
                  banner_image.image_setting_path.length > 0
              }"
            >
              <div class="text-truncate">
                {{ banner_image.image_setting_name }} {{ "- " + banner_image_width + ' X ' + banner_image_height}}
              </div>
            </div>
            <div class="uploaded-file-name">
              <div class="text-truncate pt-2">
                {{ banner_image.image_setting_path }}
              </div>
            </div>
          </label>
        </div>
        <div
          class="col-1 mb-4"
          v-if="banner_type_id"
        >
          <img
            v-if="
              banner_image.image_setting_path &&
                banner_image.image_setting_path.length > 0
            "
            :src="_GetImagePath(banner_image.image_setting_path)"
            @click="
              openImageModal(
                banner_image.image_setting_name,
                banner_image.image_setting_path
              )
            "
            height="38"
            width="38"
            class="rounded c-pointer"
          />
          <img
            v-else
            src="@/assets/img/icons/empty-image.svg"
            height="35"
            width="35"
            class="rounded"
          />
        </div> -->

          <div class="col-lg-12 col-xl-12 align-self-center row">
            <div class="col-lg-4 col-xl-3 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="from_date"
                      @click="resetFromDate('from_date')"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="from_date"
                      name="fdate1"
                      id="fdate1"
                      typeable
                      v-validate=""
                      v-b-tooltip.hover
                      :title="$t('fromdate')"
                    ></Datepicker>
                    <label :class="from_date ? 'active' : ''">From</label>
                  </div>
                </div>
                <!--Tooltip :title="$t('fromdate')" /-->
              </div>
              <!-- <p v-if="submitted && errors.has('fdate1')" class="error_message">
                {{ errors.first("fdate1") }}
              </p> -->
            </div>

            <div class="col-lg-4 col-xl-3 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="to_date"
                      @click="resetFromDate('to_date')"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="to_date"
                      name="todate"
                      id="todate"
                      typeable
                      v-validate=""
                      v-b-tooltip.hover
                      :title="$t('todate')"
                    ></Datepicker>
                    <label :class="to_date ? 'active' : ''">To</label>
                  </div>
                </div>
                <!--Tooltip :title="$t('todate')" /-->
              </div>
              <!-- <p v-if="submitted && errors.has('todate')" class="error_message">
                {{ errors.first("todate") }}
              </p> -->
            </div>

            <div class="col-lg-6 col-xl-3 my-2">
              <div class="dropdown-curve-container">
                <label
                  :class="selectedOfferId ? 'shift-up' : 'font-weight-bold'"
                  >Offers</label
                >
                <div class>
                  <multiselect
                    v-model="selectedOfferId"
                    placeholder=""
                    :options="offersList"
                    label="offer_title"
                    track-by="os_id"
                    :multiple="false"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
            <div
              class="col-2 mb-2 d-flex align-items-center justify-content-center"
            >
              <label class="mb-0">
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox"
                  v-model="fade"
                />
              </label>

              <label class="mb-0 mr-3 switch-text">{{ $t("fade") }}</label>
            </div>
            <p class="error_message">
              <span></span>
            </p>
            <div class="col-12 mb-2">
              <div
                class="d-flex align-items-center justify-content-start"
                v-if="
                  CinemasGroupedByRegion && CinemasGroupedByRegion.length > 0
                "
              >
                <h6 style="margin-bottom:0px;margin-right:10px">Cinema</h6>
                <div
                  v-for="regionObj in CinemasGroupedByRegion"
                  :key="regionObj[0]"
                  v-if="regionObj[1].length > 0"
                  class="my-1"
                >
                  <div class="d-flex align-items-center my-1">
                    <p class="m-0 cursor-pointer">
                      {{ regionObj[1][0].region_name }}:
                    </p>

                    <div class="d-flex ml-1">
                      <b-button
                        v-for="(cinema, cinemaIndex) in regionObj[1]"
                        :key="cinemaIndex"
                        :class="`mx-1 cursor-pointer custom-button`"
                        @click="onClickSelectCinema(cinema, cinemaIndex)"
                        :variant="
                          selectedCinema.findIndex(
                            (x) => x.cine_id == cinema.cine_id
                          ) !== -1
                            ? 'primary'
                            : 'outline-primary'
                        "
                        >{{ cinema.cine_code }}</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-md-4 mb-2 d-flex align-items-center justify-content-center"
                style="gap:10px"
                v-else
              >
                <h6>Select Cinema</h6>
                <p class="mt-0">
                  No cinemas found. Please add some cinemas.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 Language-section px-3 mb-2">
          <div
            v-for="(BannerLang, BannerLangIndex) in BannerContent"
            :key="BannerLangIndex"
            class="row new-border back rounded-10 mt-2 "
          >
            <h5 class="col-md-12 mt-3 mb-3 d-flex  ">
              <span>{{ BannerLang.langauge }}</span>
              <button
                @click.prevent.stop="
                  translateToOtherLangs(BannerLang, BannerLangIndex)
                "
                class="btn-blue btn-blue-sm ml-2"
              >
                Translate &nbsp;
                <b-spinner
                  v-if="translationLoading[BannerLangIndex] == true"
                  small
                  variant="light"
                  label="Spinning"
                  class="translate-spinner"
                ></b-spinner>
              </button>
            </h5>

            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="BannerLang.banner_header"
                    placeholder="."
                    name="banner_header"
                    id="banner_header"
                    maxlength="200"
                    v-on:keydown="checkInputLength"
                    v-b-tooltip.hover
                    :title="$t('banner_header')"
                  />
                  <label>Header</label>
                </div>
                <!--Tooltip :title="$t('banner_header')" /-->
              </div>
              <p class="error_message">
                <span
                  v-if="
                    submitted &&
                      BannerLang.langauge.toLowerCase() === 'english' &&
                      errors.has('banner_header')
                  "
                  >{{ errors.first("banner_header") }}</span
                >
              </p>
            </div>

            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="BannerLang.banner_subheader"
                    placeholder="."
                    name="banner_subheader"
                    id="banner_subheader"
                    maxlength="200"
                    v-on:keydown="checkInputLength"
                    v-b-tooltip.hover
                    :title="$t('banner_subheader')"
                  />
                  <label>Sub-Header</label>
                </div>
                <!--Tooltip :title="$t('banner_subheader')" /-->
              </div>
              <p class="error_message">
                <span
                  v-if="
                    submitted &&
                      BannerLang.langauge.toLowerCase() === 'english' &&
                      errors.has('banner_subheader')
                  "
                  >{{ errors.first("banner_subheader") }}</span
                >
              </p>
            </div>

            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="BannerLang.button_text"
                    placeholder="."
                    name="button_text"
                    id="button_text"
                    maxlength="255"
                    v-on:keydown="checkInputLength"
                    v-b-tooltip.hover
                    :title="$t('button_text_tooltip')"
                  />
                  <label>Button Text</label>
                </div>
                <!--Tooltip :title="$t('button_text_tooltip')" /--->
              </div>
              <p class="error_message">
                <span
                  v-if="
                    submitted &&
                      BannerLang.langauge.toLowerCase() === 'english' &&
                      errors.has('button_text')
                  "
                  >{{ errors.first("button_text") }}</span
                >
              </p>
            </div>

            <div class="col-md-4">
              <!--div class="">Image:</div-->
              <div class="row">
                <div class="col-10">
                  <div class="d-flex align-items-center">
                    <label
                      style="background-color:white;"
                      class="material-file-upload"
                      @click.prevent.stop="
                        setModalData(
                          banner_image_height,
                          banner_image_width,
                          BannerLangIndex,
                          1
                        )
                      "
                      v-b-tooltip.hover
                      src="@/assets/img/icons/question.svg"
                      :title="
                        'Web Banner' +
                          '- ' +
                          banner_image_width +
                          ' X ' +
                          banner_image_height
                      "
                    >
                      <div
                        class="label"
                        v-bind:class="{
                          'shift-up':
                            BannerLang.banner_image.image_setting_path &&
                            BannerLang.banner_image.image_setting_path.length >
                              0,
                        }"
                      >
                        {{ BannerLang.banner_image.image_setting_name }}
                        {{
                          "- " +
                            banner_image_width +
                            " X " +
                            banner_image_height
                        }}
                      </div>
                      <div class="uploaded-file-name">
                        <div class="text-truncate pt-2">
                          {{ BannerLang.banner_image.image_setting_path }}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="col-2 align-self-center pl-3">
                  <ImagePreviewer
                    :clickFunc="
                      () => {
                        openImageModal(
                          BannerLang.banner_image.image_setting_name,
                          BannerLang.banner_image.image_setting_path
                        );
                      }
                    "
                    :img="
                      _GetImagePath(BannerLang.banner_image.image_setting_path)
                    "
                    v-if="BannerLang.banner_image.image_setting_path"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-4" v-if="mobileImageSettingAvailable">
              <div class="row">
                <div class="col-10">
                  <div class="d-flex align-items-center">
                    <label
                      style="background-color:white;"
                      class="material-file-upload"
                      @click.prevent.stop="
                        setModalData(
                          mobile_banner_image_height,
                          mobile_banner_image_width,
                          BannerLangIndex,
                          2
                        )
                      "
                      v-b-tooltip.hover
                      src="@/assets/img/icons/question.svg"
                      :title="
                        'Mobile Banner' +
                          '- ' +
                          mobile_banner_image_width +
                          ' X ' +
                          mobile_banner_image_height
                      "
                    >
                      <div
                        class="label"
                        v-bind:class="{
                          'shift-up':
                            BannerLang.mobile_banner_image.image_setting_path &&
                            BannerLang.mobile_banner_image.image_setting_path
                              .length > 0,
                        }"
                      >
                        {{ BannerLang.mobile_banner_image.image_setting_name }}
                        {{
                          "- " +
                            mobile_banner_image_width +
                            " X " +
                            mobile_banner_image_height
                        }}
                      </div>
                      <div class="uploaded-file-name">
                        <div class="text-truncate pt-2">
                          {{
                            BannerLang.mobile_banner_image.image_setting_path
                          }}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="col-2 align-self-center pl-3">
                  <ImagePreviewer
                    :clickFunc="
                      () => {
                        openImageModal(
                          BannerLang.mobile_banner_image.image_setting_name,
                          BannerLang.mobile_banner_image.image_setting_path
                        );
                      }
                    "
                    :img="
                      _GetImagePath(
                        BannerLang.mobile_banner_image.image_setting_path
                      )
                    "
                    v-if="BannerLang.mobile_banner_image.image_setting_path"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="addBanner(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="addBanner(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            :to="{ path: '/master/banners' }"
            >{{ $t("cancel") }}</b-button
          >
        </div>
        <!-- MOVIE BANNER IMAGE MODAL -->
        <b-modal
          ref="preview-modal"
          id="selected-image-preview-modal"
          size="lg"
          hide-header
          hide-footer
        >
          <label class="h4 mt-2 mb-4 text-center">{{
            tempModalImageName
          }}</label>
          <button
            class="btn-modal-close"
            @click="$bvModal.hide('selected-image-preview-modal')"
          >
            &times;
          </button>
          <br />
          <img :src="_GetImagePath(tempModalImagePath)" class="img-fluid" />
        </b-modal>
        <!-- IMAGE CROPPER -->
        <b-modal
          id="imagecropper"
          body-class="banner-cropper"
          hide-header
          hide-footer
          no-close-on-backdrop
        >
          <label class="h4 mt-2 mb-4 text-center">Crop Image</label>

          <button class="btn-modal-close" v-on:click="hideCropperModal()">
            &times;
          </button>

          <vue-cropper
            ref="cropper"
            :src="imgSrc"
            :viewMode="1"
            :aspect-ratio="width / height"
            :cropBoxResizable="true"
            dragMode="none"
            alt="Source Image"
            preview=".preview"
          ></vue-cropper>
          <br />
          <button
            class="btn-blue d-block mr-auto ml-auto"
            @click.prevent.stop="cropImage"
          >
            Save
          </button>
        </b-modal>
      </div>
    </div>
    <ImageGallery
      v-bind:propImageName="banner_name ? banner_name : 'Movie Banner'"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
      :showPercentageLoader="true"
      :img_desc="banner_description ? banner_description : 'Movie Banner'"
      :resetImgData="false"
      :category="'Movie Banner'"
    ></ImageGallery>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import MarketingService from "@/services/MarketingService";
  import Vue from "vue";

  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  import ImageGallery from "../../ImageGallery/imageGalleryModal";
  import { mapGetters } from "vuex";
  import ImagePreviewer from "@/components/Partials/ImagePreviewer.vue";

  export default {
    components: { VueCropper, ImageGallery, ImagePreviewer },
    data() {
      return {
        mobileImageSettingAvailable: false,
        btenable: false,
        banner_name: "",
        banner_header: "",
        banner_subheader: "",
        banner_is_active: true,
        fade: true,
        submitted: false,
        banner_description: "",
        from_date: "",
        to_date: "",
        banner_image: {
          image_setting_name: "Banner Image",
          image_setting_path: null,
          image_setting_static_path: "",
          image_setting_baseurl: "",
          image_setting_showpath: "",
        },
        mobile_banner_image: {
          image_setting_name: "Banner Image",
          image_setting_path: null,
          image_setting_static_path: "",
          image_setting_baseurl: "",
          image_setting_showpath: "",
        },
        file: null,
        filename: null,
        width: null,
        height: null,
        cropImg: null,
        tempModalImageName: null,
        tempModalImagePath: null,
        imgSrc: null,
        MovieList: [],
        MovieListCopy: [],
        movie_name: "",
        movie_id: null,
        searchMovie: "",
        isMovieSelected: false,
        isGenericURL: false,
        generic_url: "",
        banner_type_id: null,
        banner_type: "",
        banner_types: [],
        MovieContentContainer: [],
        postersList: [],
        scenesList: [],
        cinemas: [],
        cinema_id: null,
        cinemaSelected: null,
        CinemasGroupedByRegion: [],
        selectedCinema: [],
        ContentLanguages: [],
        BannerContent: [],
        BannerContentCopy: [],
        translationLoading: [false, false, false, false, false, false],
        translated: [false, false, false, false, false, false],
        banner_image_height: "",
        banner_image_width: "",
        mobile_banner_image_height: "",
        mobile_banner_image_width: "",
        imageBannerIndex: "",
        set_width: null,
        set_height: null,
        showModal: false,
        movie_banner_type_id: 1,
        uploadType: 1,
        movieType: [
          {
            id: 1,
            name: "Now Showing",
            checked: true,
          },
          {
            id: 2,
            name: "On Demand",
            checked: false,
          },
          {
            id: 3,
            name: "Upcoming",
            checked: false,
          },
        ],
        offersList: [],
        selectedOfferId: { os_id: null, offer_title: null },
      };
    },
    beforeMount() {
      this.cinema_id = this.secureStore.get("USINFO").cinema_id || null;
      this.getMoviesList();
      this.getBannerTypes();
      this.getCinemas();
      this.getContentLangauge();
      this.getOffersList();
    },
    computed: {
      ...mapGetters(["finalImagePath"]),
      movie_type_id() {
        let tempArr = [];
        this.movieType.map((x) => {
          if (x.checked) {
            tempArr.push(x.id);
          }
        });
        return tempArr.toString();
      },
    },
    watch: {
      finalImagePath(newval) {
        if (this.uploadType == 2) {
          this.BannerContent[
            this.imageBannerIndex
          ].mobile_banner_image.image_setting_path = newval;
        } else {
          this.BannerContent[
            this.imageBannerIndex
          ].banner_image.image_setting_path = newval;
        }
      },
    },
    methods: {
      checkInputLength(event) {
        console.log("event", event);
        let maxlength = event.target.maxLength;
        var regex = new RegExp("^[a-zA-Z0-9 ]+$");
        var str = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );
        if (
          event.target.value.length >= event.target.maxLength &&
          regex.test(str)
        ) {
          this.$toasted.show(
            `Limit Reached. Only ${maxlength} characters are allowed.`
          );
        }
      },
      setModalData(height, width, index, uploadType = 1) {
        this.imageBannerIndex = index;
        this.set_height = height;
        this.set_width = width;
        this.uploadType = uploadType;
        this.showModal = !this.showModal;
      },
      async getCinemas() {
        try {
          const { data } = await MasterService.GetCinemas({
            cine_id: this.cinema_id,
          });
          if (data && data.status && data.Records.length > 0) {
            this.cinemas = data.Records;
            this.CinemasGroupedByRegion = _.toPairs(
              _.groupBy(
                data.Records.filter((x) => x.region_id),
                "region_id"
              )
            );
          }
        } catch (error) {
          console.error(error);
        }
      },
      _getMoviesList: function() {
        let loader = this.$loading.show();
        MovieService.GetActiveMoviesWithFormat()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.MovieList = data.Records;
              this.MovieListCopy = data.Records;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      getMoviesList: function() {
        let loader = this.$loading.show();
        let payload = {
          movie_is_active: "Y",
        };
        MovieService.GetActiveMasterMovies(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.MovieList = data.Records;
              this.MovieListCopy = data.Records;
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch Error on getAllActiveMovies :", error);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      resetFromDate(type) {
        if (type == "from_date") {
          this.from_date = "";
        } else if (type == "to_date") {
          this.to_date = "";
        }
      },
      getContentLangauge: function() {
        MovieService.GetMovieContentLanguages()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.ContentLanguages.length > 0) {
                // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
                //   "langauge"
                // ]);
                this.ContentLanguages = data.ContentLanguages;
              }
              console.log("this.ContentLanguages", this.ContentLanguages);
            } else {
              // Show Error:
              console.log("data.message :", data.message);
            }
            return;
          })
          .then(() => {
            this.makeLangContainers();
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error On getMovieContentLangauge :", error);
          });
      },
      makeLangContainers: function() {
        this.ContentLanguages.map((x) => {
          let Obj = {
            ...x,
            banner_name: "",
            banner_header: "",
            banner_subheader: "",
            banner_description: "",
            button_text: "",
            banner_image: {
              image_setting_name: "Web Banner",
              image_setting_path: null,
              image_setting_static_path: "",
              image_setting_baseurl: "",
              image_setting_showpath: "",
            },
            mobile_banner_image: {
              image_setting_name: "Mobile Banner",
              image_setting_path: null,
              image_setting_static_path: "",
              image_setting_baseurl: "",
              image_setting_showpath: "",
            },
          };
          this.BannerContent.push(Obj);
          this.BannerContentCopy.push(JSON.parse(JSON.stringify(Obj)));
          console.log("this.BannerContent", this.BannerContent);
        });
      },
      translateToOtherLangs: function(Content, index) {
        /* movieDescription
movieShortDescription */
        let englishContent = this.BannerContent.find((x) => {
          if (
            (x.banner_header && x.banner_header.length > 0) ||
            (x.banner_subheader && x.banner_subheader.length > 0)
          ) {
            return true;
          }
        });

        if (
          !englishContent ||
          !englishContent.banner_header ||
          !englishContent.banner_subheader
        ) {
          this.$toasted.show("Please enter all details for any language");
          return;
        }

        let targetLang = Content.iso_2;

        if (!targetLang) {
          this.$toasted.show(
            "No ISO code found for " + Content.langauge + "language"
          );
          return;
        }
        this.translationLoading[index] = true;

        this.$forceUpdate();

        MovieService.GetDeeplTranslations({
          target_langs: [targetLang],
          text: [
            englishContent.banner_header,
            englishContent.banner_subheader,
            englishContent.button_text,
          ],
        })
          .then((resp) => {
            const { data } = resp;
            console.log("data", data);

            if (data.status) {
              let translations = data.data[targetLang].translations;
              Content.banner_header = translations[0].text;
              Content.banner_subheader = translations[1].text;
              Content.button_text = translations[2].text;
              this.translated[index] = true;
            }
          })
          .catch((err) => {
            this.$toasted.show("Error when fetching translations");
            console.log("Error while fetching translations");
            console.log(err);
          })
          .finally(() => {
            this.translationLoading[index] = false;
            this.$forceUpdate();
          });
      },
      onClickSelectCinema(cinema, index) {
        // let isExists = this.selectedCinema.find((x) => {
        //   return x.cine_id == cinema.cine_id
        // })
        // if(isExists) {
        //   this.selectedCinema.splice(this.selectedCinema.findIndex(function(i){
        //     return i.cine_id === cinema.cine_id;
        // }), 1);
        // } else {
        //   this.selectedCinema.push(cinema);
        // }
        let isExists = this.selectedCinema.findIndex(
          (x) => x.cine_id == cinema.cine_id
        );
        if (isExists !== -1) {
          this.selectedCinema.splice(isExists, 1);
        } else {
          this.selectedCinema.push(cinema);
        }
        console.log("selectedScreens", this.selectedCinema);
      },
      getBannerTypes: function() {
        MasterService.GetBannerTypes().then((res) => {
          const { data } = res;
          if (data.status) {
            this.banner_types = data.Records;
            if (data.bannerSettings) {
              let webbanner = data.bannerSettings.filter(
                (x) => x.image_setting_name.toLowerCase() == "web banner"
              );
              if (webbanner && webbanner.length > 0) {
                this.banner_image_height = webbanner[0].image_setting_height;
                this.banner_image_width = webbanner[0].image_setting_width;
              }

              let mobilebanner = data.bannerSettings.filter(
                (x) =>
                  x.image_setting_name.toLowerCase() == "mobile banner" &&
                  x.image_setting_is_active == "Y"
              );
              if (mobilebanner && mobilebanner.length > 0) {
                this.mobileImageSettingAvailable = true;
                this.mobile_banner_image_height =
                  mobilebanner[0].image_setting_height;
                this.mobile_banner_image_width =
                  mobilebanner[0].image_setting_width;
              }
            }
          }
        });
      },
      onSearchMovie: function(value) {
        if (this.searchMovie && this.searchMovie.length > 0) {
          this.MovieList = this.MovieListCopy.filter((x) => {
            if (
              x.movie_title
                .toLowerCase()
                .includes(this.searchMovie.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.MovieList = this.MovieListCopy;
        }
      },
      onSelectBannerType: function(data) {
        this.banner_type = data.banner_type;
        this.banner_type_id = data.banner_type_id;
      },
      onSelectMovie: function(data) {
        // this.isMovieSelected = true;
        this.movie_name = data.movie_title;
        this.movie_id = data.movie_id;
        this.banner_name = data.movie_title;
        // this.banner_header = data.movie_title;
        // this.banner_subheader = data.lang_name + " " + data.mf_name;
        // this.banner_description = data.mc_plot;
        this.banner_description = data.movie_title;
        this.BannerContent.map((x) => {
          if (x.langauge.toLowerCase() == "english") {
            // x.banner_name = data.movie;
            x.banner_header = data.movie_title;
            // x.banner_subheader = data.lang_name + " " + data.mf_name;
            x.banner_subheader = data.movie_title;
            // x.banner_description = data.mc_plot;
          }
        });
        this.banner_image.image_setting_path = "";
        // this.tempModalImageName = "Banner Image";
        // this.tempModalImagePath = data.mp_poster_url;
        this.generic_url = `/movie-details/${data.movie_id}/${data.original_lang_id}`;

        this.getMovieDetails(data.movie_id, data);
      },
      onResetForm: function() {
        this.isMovieSelected = false;
        this.movie_name = "";
        this.movie_id = null;
        this.banner_name = "";
        this.banner_header = "";
        this.banner_subheader = "";
        this.banner_description = "";
        this.banner_is_active = true;
        this.fade = true;
        this.banner_image.image_setting_path = "";
        this.tempModalImageName = "";
        this.tempModalImagePath = "";
        this.generic_url = "";
        this.banner_type_id = null;
        this.banner_type = "";
        this.from_date = "";
        this.to_date = "";
        this.selectedCinema = [];
        this.BannerContent = JSON.parse(JSON.stringify(this.BannerContentCopy));
        this.translationLoading = [false, false, false, false, false, false];
        this.translated = [false, false, false, false, false, false];
        // this.banner_image_height = "";
        // this.banner_image_width = "";
        // this.imageBannerIndex = "";
        // this.set_width = null;
        // this.set_height = null;
        this.$forceUpdate();
      },
      OnType: function(event) {
        if (this.generic_url.length > 0 && this.movie_id != null) {
          this.isGenericURL = false;
        } else if (this.generic_url.length > 0) {
          this.isGenericURL = true;
        } else {
          this.isGenericURL = false;
        }
      },
      setBannerImage: function(e, index) {
        this.imageBannerIndex = index;
        this.file = e.target.files[0];
        this.filename = e.target.files[0]["name"];
        //   this.indexofthubmnail = PosterIndex;
        //   this.movieindex = MovieContentIndex;

        // 3050x2160

        this.width = this.banner_image_width;
        this.height = this.banner_image_height;

        if (this.file.type.indexOf("image/") === -1) {
          this.$toasted.show("Please select an image file");
          return;
        }
        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;

            this.$bvModal.show("imagecropper");
            e.target.value = "";
          };
          reader.readAsDataURL(this.file);
        } else {
          // alert("Sorry, FileReader API not supported");
        }
      },
      cropImage() {
        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
        //   console.log(this.data);
        var block = this.cropImg.split(";");
        // Get the content type of the image
        var contentType = block[0].split(":")[1]; // In this case "image/gif"
        // get the real base64 content of the file
        var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
        // Convert it to a blob to upload
        var blob1 = this.b64toBlob(realData, contentType);
        this.onFileUpload(blob1, this.filename);
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      onFileUpload: function(image, filename) {
        //   let loader = this.$loading.show();

        let formData = new FormData();
        formData.append("image", image, filename);
        formData.append("imagePath", "Banner Image");
        // formData.append("imagePath", PosterItem.image_setting_static_path);
        MasterService.GlobalUploadImage(formData)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              // this.MovieContentContainer[MovieContentIndex].moviePosters[
              //   PosterIndex
              // ].image_setting_path = data.path;
              this.onSetImagePath(data);
              this.$bvModal.hide("imagecropper");
            } else {
              data["message"] && data["message"]["message"]
                ? this.$toasted.show(data.message.message)
                : this.$toasted.show(
                    data.message ||
                      "Sorry! Something went wrong. kindly contact your administrator"
                  );
            }
          })
          .catch(this._CatchError);
        // .finally(() => {
        //   setTimeout(() => loader.hide(), 1000);
        // });
      },
      onSetImagePath: function(data, MovieContentIndex, PosterIndex) {
        //   let Obj = this.banner_image;
        //   console.log("Obj :>> ", Obj);
        //   let _Obj = {
        //     ...Obj,
        //     image_setting_path: data.path
        //   };
        //   Vue.set(this.banner_image, _Obj);
        this.BannerContent[
          this.imageBannerIndex
        ].banner_image.image_setting_path = data.path;
        // this.banner_image.image_setting_path = data.path;
        console.log("this.banner_image :>> ", this.banner_image);
        console.log("this.BannerContent :>> ", this.BannerContent);
      },
      openImageModal: function(image_name, image_path) {
        this.tempModalImagePath = image_path;
        this.tempModalImageName = image_name;
        this.$refs["preview-modal"].show();
      },
      hideCropperModal: function() {
        this.$bvModal.hide("imagecropper");
      },
      addBanner(flag) {
        this.submitted = true;
        console.log("this.bannerLang", this.BannerContent);
        if (!this.banner_type) {
          return this.$toasted.show("Please Select Banner Type");
        } else if (this.selectedCinema.length == 0) {
          return this.$toasted.show("Please Select Cinema");
        } else if (this.from_date > this.to_date) {
          return this.$toasted.show("To Date must be greater than From Date");
        } else if (this.banner_type_id == 1 && !this.movie_type_id) {
          return this.$toasted.show("Please Select Movie Type");
        }
        this.$validator.validate().then((valid) => {
          let checkBanner = true;
          if (valid) {
            // if (this.movie_id == null && this.generic_url.length == 0) {
            //   return this.$toasted.show(
            //     "Please Select Movie or Enter Generic URL"
            //   );
            // }

            let engBanner = this.BannerContent.filter(
              (x) => x.langauge.toLowerCase() == "english"
            );
            let fallbackBanner = this.BannerContent.filter(
              (x) => !!x.banner_image.image_setting_path
            );

            this.BannerContent.forEach((x) => {
              if (
                engBanner.length &&
                engBanner[0].banner_image.image_setting_path
              ) {
                if (!x.banner_image.image_setting_path) {
                  x.banner_image.image_setting_path =
                    engBanner[0].banner_image.image_setting_path;
                }

                if (
                  !x.mobile_banner_image.image_setting_path &&
                  engBanner[0].mobile_banner_image.image_setting_path
                ) {
                  x.mobile_banner_image.image_setting_path =
                    engBanner[0].mobile_banner_image.image_setting_path;
                }
              } else if (fallbackBanner.length) {
                if (
                  !x.banner_image.image_setting_path &&
                  fallbackBanner[0].banner_image.image_setting_path
                ) {
                  x.banner_image.image_setting_path =
                    fallbackBanner[0].banner_image.image_setting_path;
                }

                if (
                  !x.mobile_banner_image.image_setting_path &&
                  fallbackBanner[0].mobile_banner_image.image_setting_path
                ) {
                  x.mobile_banner_image.image_setting_path =
                    fallbackBanner[0].mobile_banner_image.image_setting_path;
                }
              }
            });

            console.log({
              engBanner,
              fallbackBanner,
              BannerContent: this.BannerContent.map((x) => x),
            });

            this.BannerContent.map((x) => {
              if (
                x.langauge.toLowerCase() == "english" &&
                !x.banner_image.image_setting_path
              ) {
                checkBanner = false;
              }
            });

            if (
              // this.banner_image.image_setting_path &&
              // this.banner_image.image_setting_path.length > 0
              checkBanner
            ) {
              // let loader = this.$loading.show();
              this.btenable = true;
              // console.log("JSON.stringify :", JSON.stringify(finalObj));
              let payload = {
                movie_id: this.movie_id,
                generic_url: this.generic_url,
                banner_name: this.banner_name,
                movie_banner_type_id:
                  this.banner_type_id == 1 ? this.movie_banner_type_id : null,
                banner_description: this.banner_description,
                movie_type_id:
                  this.banner_type_id == 1 ? this.movie_type_id : "",
                // banner_header: this.banner_header,
                // banner_subheader: this.banner_subheader,
                BannerContent: this.BannerContent,
                selectedCinema: this.selectedCinema,
                from_date: this.from_date,
                to_date: this.to_date,
                image_url: this.banner_image.image_setting_path,
                banner_is_active: this.banner_is_active,
                fade: this.fade,
                banner_type_id: this.banner_type_id,
                banner_os_id: this.selectedOfferId.os_id,
                // cinema_id: this.cinemaSelected.cine_id
              };
              MasterService.AddBanner(payload)
                .then((response) => {
                  this.btenable = false;
                  const { data } = response;
                  // loader.hide();
                  if (data && data.status) {
                    this.$toasted.show(data.message);
                    this.onResetForm();
                    if (flag) {
                      this.$router.push({
                        path: "/master/banners",
                      });
                    }
                  } else {
                    this.btenable = false;
                    this.$toasted.show(data.message);
                  }
                })
                .catch(this._CatchError)
                .finally(() => {
                  this.btenable = false;
                });
            } else {
              this.$toasted.show(
                "Please select a banner image for english language"
              );
            }
          }
        });
      },
      getMovieDetails(movie_id, movieDetails) {
        let loader = this.$loading.show();

        let payload = {
          movie_id,
        };

        this.postersList = [];
        this.scenesList = [];

        MovieService.GetEditMoviesDetails(payload)
          .then((response) => {
            const { data } = response;
            console.log("data :", data);
            if (data && data.status) {
              this.MovieContentContainer = _.sortBy(
                data.MovieContentContainer,
                ["langauge"]
              );
            } else {
              // Show Message Here
              console.log("data.message :", data.message);
              this.$toasted.show("Unable to fetch movie details").show();
            }

            console.log(
              "this.MovieContentContainer",
              this.MovieContentContainer
            );
            return data;
          })
          .then((data) => {
            let MovieContentContainer = data.MovieContentContainer;

            for (let content of MovieContentContainer) {
              let posters = content.moviePosters;
              let scenes = content.movieScenes;

              posters.forEach((poster) => {
                if (poster.image_setting_path) {
                  this.postersList.push({
                    ...poster,
                    language: content.langauge,
                  });
                }
              });

              scenes.forEach((scene) => {
                if (scene.image_path) {
                  this.scenesList.push({
                    ...scene,
                    language: content.langauge,
                  });
                }
              });
            }

            if (this.postersList.length > 0) {
              console.log(this.BannerContent, "BannerContent");
              this.BannerContent.map((x) => {
                this.postersList.map((y) => {
                  if (x.langauge.toLowerCase() == y.language.toLowerCase()) {
                    x.banner_image.image_setting_path = y.image_setting_path;
                  }
                  if (
                    x.langauge.toLowerCase() == y.language.toLowerCase() &&
                    (y.image_setting_name || "")
                      .toLowerCase()
                      .includes("mobile banner")
                  ) {
                    x.mobile_banner_image.image_setting_path =
                      y.image_setting_path;
                  }
                });
              });
            }

            console.log("this.posterList", this.postersList);
            if (this.postersList.length === 0 && this.scenesList.length === 0) {
              this.banner_image.image_setting_path =
                movieDetails.md_thumbnail_url;
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      onSelectPoster(poster) {
        console.log("poster", poster);
        this.banner_image.image_setting_path = poster.image_setting_path;
        this.tempModalImageName = "Banner Image";
        this.tempModalImagePath = poster.image_setting_path;
      },
      onSelectScene(scene) {
        console.log("scene", scene);
        this.banner_image.image_setting_path = scene.image_path;
        this.tempModalImageName = "Banner Image";
        this.tempModalImagePath = scene.image_path;
      },
      getOffersList: async function() {
        try {
          const response = await MarketingService.getOffersForBanners();
          const { data } = response;
          if (data.status && data.Records.length) {
            this.offersList = data.Records;
            return;
          }

          return this.$toasted.show(data.message);
        } catch (error) {
          console.log({ error });
        }
      },
    },
  };
</script>

<style scoped>
  .dropdown-toggle {
    width: 100%;
  }

  .btn-dropdown-curve {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .img-preview:hover {
    left: -430px !important;
  }

  .switch-text {
    line-height: 30px;
  }

  .new-border {
    border: 2px solid #b1b4b8;
  }

  label {
    color: black !important;
  }

  .internal-border-new {
    border: 1px solid var(--blue);
    /*background-color: #e6e6f8;*/
  }

  .internal-border {
    border: 1px solid var(--blue);
    background-color: #e6e6f8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
  }

  .fs {
    font-size: 17px;
  }

  .back {
    background-color: #fff;
  }

  .mar {
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/BannerComponents/addBanner.vue